import * as React from 'react'
import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'

export type SectionHeaderProps = {
  eyebrow?: string
  title: React.ReactNode
  subtitle?: React.ReactNode
  align?: 'center' | 'left'
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const titleSizes: Record<NonNullable<SectionHeaderProps['size']>, string> = {
  sm: 'text-2xl lg:text-3xl',
  md: 'text-3xl lg:text-4xl',
  lg: 'text-4xl lg:text-5xl',
  // Make xl slightly smaller on mobile for better fit, keep desktop large
  xl: 'text-4xl lg:text-5xl xl:text-6xl',
}

export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  size = 'md',
  className,
}: SectionHeaderProps) {
  const isCenter = align === 'center'
  return (
    <div
      className={cn(
        'space-y-4',
        isCenter ? 'text-center' : 'text-left',
        className
      )}
    >
      {eyebrow ? (
        <div className={cn(isCenter ? 'mx-auto' : undefined)}>
          <Badge className='bg-[hsl(var(--primary-blue))] text-white border-0'>
            {eyebrow}
          </Badge>
        </div>
      ) : null}

      <h2 className={cn('font-bold text-foreground', titleSizes[size])}>
        {title}
      </h2>

      {subtitle ? (
        <p
          className={cn(
            'text-muted-foreground',
            'text-base md:text-lg',
            isCenter ? 'max-w-2xl mx-auto' : 'max-w-2xl'
          )}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  )
}

export default SectionHeader
